import config from '../configuration';
import type { CtaType } from '../cta';

export let didCallPartnerVisit = false;

export async function logToPartnerVisit(page_type: string): Promise<void> {
  try {
    if (!config.partner?.partner_identifier) return;
    if (didCallPartnerVisit) return;
    didCallPartnerVisit = true;
    const partnerVisitUrl = `${config.urls.apiBaseUrl}/api/v1/partners/${config.partner?.partner_identifier}/widgets/partner_visit/`;
    const data = {
      page_type: page_type,
      origin_url: globalThis.location.href
    };
    const result = await fetch(partnerVisitUrl, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (result.status === 200) {
      return;
    }
  } catch (err) {
    console.debug(`unable to log partner visit: ${err}`);
  }
  didCallPartnerVisit = false;
}

// using this function only for testing. since we cannot update didCallPartnerVisit directly when imported.
export function updateDidCallPartnerVisit(visited: boolean) {
  didCallPartnerVisit = visited;
}

export async function logToPartnerCtaClick(page_type: string, cta_type: CtaType): Promise<void> {
  try {
    if (!config.partner?.partner_identifier) return;
    const partnerCtaClickUrl = `${config.urls.apiBaseUrl}/api/v1/partners/${config.partner.partner_identifier}/widgets/cta_click/`;
    const data = {
      page_type,
      cta_type,
      origin_url: globalThis.location.href
    };
    const result = await fetch(partnerCtaClickUrl, {
      method: 'POST',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (result.status === 200) {
      return;
    }
    console.debug(`unable to log partner cta click: status ${result.status}`);
  } catch (err) {
    console.debug(`unable to log partner cta click: ${err}`);
  }
}
